import React from 'react'
import BlogPost from './BlogPost'

export default function YearEnd() {
  return (
    <BlogPost
      translationKey="yearEnd"
      seoTitle="2020 Year End Review | Hyunjin Jae"
      seoDescription="A reflection on the past year, looking back at achievements, challenges, and lessons learned."
      seoKeywords="year end, reflection, personal growth, achievements, lessons learned"
      seoTags={['reflection', 'year end', 'personal growth']}
    />
  )
} 